// MUI
import { Typography } from "@mui/material";

// Utils
import { getFormattedDate } from "@dealerwave/dw-layer-date-converter";

// Components
import InformationCard from "@/Washouts/components/tables/Common/InformationCard";

// Constants
import { DATE_FORMAT } from "@Constants/date";

// Types
import { IColumnDefinition, IWrapperCard } from "@/Washouts/types/commons";

export default function LongevityCard({ data, loading, minRows, columnsOverride, ...props }: Readonly<IWrapperCard>) {
	const hideCompensation = data.every((row) => !row.compensation);
	const columns: IColumnDefinition[] = [
		{
			field: "hiredDate",
			header: "Hired Date",
			type: "date",
			width: 90,
			alignHeader: "left",
			alignCell: "left",
			...columnsOverride?.find((column) => column.field === "hiredDate"),
			cellRender: (row) => {
				return (
					<Typography component={"span"} className={"!text-default !font-montserrat !text-sm !font-semibold"}>
						{getFormattedDate(row.hiredDate, "UTC", DATE_FORMAT.monthAbbrDatePadded)}
					</Typography>
				);
			},
		},
		{
			field: "years",
			header: "Longevity (Yrs)",
			type: "integer",
			width: 122,
			alignHeader: "right",
			alignCell: "right",
			...columnsOverride?.find((column) => column.field === "years"),
		},
	];
	if (!hideCompensation) {
		columns.push({
			field: "compensation",
			header: "Comp.",
			type: "money",
			width: 85,
			alignHeader: "left",
			alignCell: "right",
			...columnsOverride?.find((column) => column.field === "compensation"),
		});
	}

	return (
		<InformationCard
			title="Longevity"
			rows={data}
			minRows={minRows}
			loading={loading}
			cellMargin={props.cellMargin}
			columns={columns}
			heightAdjustment={props?.heightAdjustment}
		/>
	);
}
